class DeliveryMain {
  constructor() {
    this.customObj = window.customObj;
    this.cart = customObj.cartJson;
    this.switchInput = ".cart-delivery-input";
    this.skipHandles = ["insurance"];
    this.checkoutPage = 0;
    this.variant_id = 45782675456238;
  }

  setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  };

  getCookie = (cname) => {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') { c = c.substring(1); }
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
  }

  checkEligibility = () => {
    let that = this;
    let cartTotal = 0;
    let filterItems = that.skipProducts();
    filterItems.map(item => { cartTotal = cartTotal + item.final_line_price; });
    if (cartTotal === 0) {
      that.removeDeliveryProduct();
      return;
    }
  }

  deliverySwitchButton = () => {
    const that = this;
    var inputs = document.querySelectorAll(that.switchInput);
    inputs.forEach((ele) => {
      let elNext = ele.nextElementSibling;
      elNext.addEventListener('click', (event) => {
        event.target.previousElementSibling.click();
      });
      ele.addEventListener("change", (event) => {
        if (event.currentTarget.checked) {
          window._deliveryRemovedThisSession = false;
          that.addDeliveryProduct();
        } else {
          window._deliveryRemovedThisSession = true;
          that.removeDeliveryProduct();
        }
      });
    });
  }

  switchOnDelivery = (b) => {
    const that = this;
    let elements = document.querySelectorAll('.delivery-con-description');
    elements.forEach((element) => { element.classList.add('hide'); });
    if (b) {
      elements = document.querySelectorAll('.delivery-con-description.opt-in');
      elements.forEach((element) => { element.classList.remove('hide'); });
    } else {
      elements = document.querySelectorAll('.delivery-con-description.opt-out');
      elements.forEach((element) => { element.classList.remove('hide'); });
    }
    var x = document.querySelectorAll(that.switchInput);
    for (let i = 0; i < x.length; i++) { x[i].checked = b; }
    try { customObj.enableSwitch(b); } catch (e) {}
  }

  addDeliveryProduct = () => {
    const that = this;
    let vid = that.variant_id;
    let updates = {};
    updates[vid] = 1;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-REF': '1' },
      body: JSON.stringify({
        updates: updates,
        attributes: { 'delivery-confirmation': '1' }
      })
    })
    .then(response => {
      if (response.status == 200) {
        response.json().then(res => {
          that.updateCartJson();
          that.switchOnDelivery(true);
          customObj.cartReload(0);
          if (this.checkoutPage) OrderSummaryUpdater.prototype.refresh();
        });
      }
    })
    .catch((error) => { console.error('Error:', error); });
  }

  updateProductQty = () => {
    const that = this;
    let updates = {};
    let deliveryProduct = this.getDeliveryProduct();
    if (deliveryProduct.length === 0) return;
    deliveryProduct.map(item => { updates[item.id] = 0; return item; });
    updates[deliveryProduct[0].id] = 1;
    that.switchOnDelivery(false);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-REF': '1' },
      body: JSON.stringify({ updates: updates })
    })
    .then(response => {
      if (response.status == 200) {
        response.json().then(res => {
          that.updateCartJson();
          customObj.cartReload(1);
          if (this.checkoutPage) OrderSummaryUpdater.prototype.refresh();
        });
      }
    })
    .catch((error) => { console.error('Error:', error); });
  }

  removeDeliveryProduct = (callback) => {
    let updates = {};
    let deliveryProduct = this.getDeliveryProduct();
    if (deliveryProduct.length === 0) return;
    deliveryProduct.map(item => { updates[item.id] = 0; return item; });
    this.switchOnDelivery(false);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-REF': '1' },
      body: JSON.stringify({
        updates: updates,
        attributes: { 'delivery-confirmation': '0' }
      })
    })
    .then(response => {
      if (response.status == 200) {
        if (typeof (callback) === 'function') {
          callback();
        } else {
          response.json().then(res => {
            this.updateCartJson();
            customObj.cartReload(0);
            if (this.checkoutPage) OrderSummaryUpdater.prototype.refresh();
            return true;
          });
        }
      }
    })
    .catch((error) => { console.error('Error:', error); });
  }

  updateCartJson = () => {
    fetch('/cart.json', {})
    .then(response => response.json())
    .then(data => {
      customObj.cartJson = data;
      this.cart = data;
      var input = document.querySelector(this.switchInput);
      if (input) input.disabled = false;
    });
  }

  switchCheck = () => {
    const that = this;
    let deliveryItems = that.getDeliveryProduct();
    if (deliveryItems.length > 0) {
      that.switchOnDelivery(true);
    } else {
      that.switchOnDelivery(false);
    }
  }

  // Returns all cart items that are NOT the delivery-confirmation product
  // and NOT in the skipHandles list (e.g. insurance)
  // Used by checkEligibility to determine if real products are in the cart
  skipProducts = () => {
    let that = this;
    let items = [];
    if (this.cart) {
      items = this.cart.items.filter(item => {
        return item.variant_id != that.variant_id &&
               that.skipHandles.indexOf(item.handle) === -1;
      });
    }
    return items;
  }

  // Returns items that ARE the delivery-confirmation product (used by removeDeliveryProduct)
  getDeliveryProduct = () => {
    let items = [];
    if (this.cart) {
      items = this.cart.items.filter(item => this.variant_id == item.variant_id);
    }
    return items;
  }

  autoAddProduct = () => {
    const that = this;

    // Never auto-add if customer explicitly unchecked this session
    if (window._deliveryRemovedThisSession) return;

    // Never auto-add if there are no real products in the cart
    // (prevents re-adding after all items removed)
    if (that.skipProducts().length === 0) return;

    // Auto-add if not already in cart and toggle is off
    if (document.querySelector(that.switchInput) && !document.querySelector(that.switchInput).checked) {
      if (that.getDeliveryProduct().length === 0) {
        that.switchOnDelivery(true);
        that.addDeliveryProduct();
      }
    }
  }

  init = () => {
    if (customObj && customObj.delivery_confirmation_enable) {
      this.checkEligibility();
      this.switchCheck();
      this.deliverySwitchButton();
      this.autoAddProduct();
    }
  }
}

let deliveryObj = new DeliveryMain;
deliveryObj.init();

customObj.loadApp = function () {
  fetch('/cart.json', {})
  .then(response => response.json())
  .then(data => {
    customObj.cartJson = data;
    let cartObj = new DeliveryMain();
    cartObj.init();
  })
  .catch((error) => { console.error('Error:', error); });
}